import { useToast } from '../store/toast.js';
import type { ToastKind } from '../store/toast.js';

const KIND_ICON: Record<ToastKind, string> = { success: '✓', error: '!', info: 'i' };
const KIND_CLASS: Record<ToastKind, string> = {
  success: 'toast-success',
  error: 'toast-error',
  info: 'toast-info',
};

/** 应用内提示（替代 window.alert；错误提示 9 秒自动消失，可手动关闭）。 */
export function ToastHost() {
  const items = useToast((state) => state.items);
  const dismiss = useToast((state) => state.dismiss);

  if (items.length === 0) return null;

  return (
    <div className="toast-host">
      {items.map((item) => (
        <div
          key={item.id}
          className={`toast ${KIND_CLASS[item.kind]}`}
          role={item.kind === 'error' ? 'alert' : 'status'}
          aria-live={item.kind === 'error' ? 'assertive' : 'polite'}
        >
          <span className="toast-ico" aria-hidden="true">
            {KIND_ICON[item.kind]}
          </span>
          <div className="toast-body grow">
            <div className="toast-msg">{item.message}</div>
            {item.detail !== undefined ? <div className="toast-detail">{item.detail}</div> : null}
          </div>
          <button type="button" className="toast-close" aria-label="关闭提示" onClick={() => dismiss(item.id)}>
            ×
          </button>
        </div>
      ))}
    </div>
  );
}